'use client';
import { ImageWithFallback } from "./image-will-fallback";
import { Card } from "./ui/card";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "./ui/carousel";

const screenshots = [
  {
    title: "Dashboard Overview",
    description: "Get a bird's eye view of all your projects and their status at a glance",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200&q=80",
  },
  {
    title: "Smart Data Extraction",
    description: "Upload PDFs and watch as our AI extracts structured data automatically",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=1200&q=80",
  },
  {
    title: "Organized Tables",
    description: "View and manage extracted data in clean, organized tables with VS Code-style tabs",
    image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=1200&q=80",
  },
];

export function ScreenshotsCarousel() {
  return (
    <section className="container mx-auto px-4 py-16 md:py-24">
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-mono mb-4">See it in action</h2>
        <p className="text-muted-foreground max-w-2xl mx-auto">
          From visual schema design to relational data extraction—watch PdfParse transform your document workflow
        </p>
      </div>

      <div className="max-w-5xl mx-auto">
        <Carousel
          opts={{
            align: "start",
            loop: true,
          }}
          className="w-full"
        >
          <CarouselContent>
            {screenshots.map((screenshot, index) => (
              <CarouselItem key={index}>
                <div className="p-1">
                  <Card className="overflow-hidden">
                    <div className="aspect-video bg-muted relative overflow-hidden">
                      <ImageWithFallback
                        src={screenshot.image}
                        alt={screenshot.title}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div className="p-6 text-center">
                      <h3 className="text-xl font-mono mb-2">{screenshot.title}</h3>
                      <p className="text-sm text-muted-foreground">
                        {screenshot.description}
                      </p>
                    </div>
                  </Card>
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselPrevious className="left-4" />
          <CarouselNext className="right-4" />
        </Carousel>
      </div>
    </section>
  );
}
